import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SnackbarNotification {
  id: string;
  message: string;
  severity: 'success' | 'info' | 'warning' | 'error';
  autoHideDuration?: number;
}

interface NotificationState {
  notifications: SnackbarNotification[];
}

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    enqueueSnackbar: (state, action: PayloadAction<Omit<SnackbarNotification, 'id'>>) => {
      const id = new Date().getTime().toString();
      state.notifications.push({
        ...action.payload,
        id,
      });
    },
    removeSnackbar: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearSnackbars: (state) => {
      state.notifications = [];
    },
  },
});

export const { enqueueSnackbar, removeSnackbar, clearSnackbars } = notificationSlice.actions;

export default notificationSlice.reducer; 